<template>
  <v-dialog
    v-model="dialog"
    persistent
    width="1000"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-bind="attrs"
        @click="onOpen"
        v-on="on"
      >
        Configure King Street Computers
      </v-btn>
    </template>
    <v-card>
      <v-card-title>Configure King Street Computers</v-card-title>

      <v-card-text>
        <v-col>
          <v-row>
            <v-text-field label="Auth Token" v-model="credentials.authToken"></v-text-field>
          </v-row>
          <v-row>
            <v-text-field label="Company ID" v-model="credentials.idcompany"></v-text-field>
          </v-row>
        </v-col>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="normal"
          text
          @click="dialog = false"
        >
          Cancel
        </v-btn>
        <v-btn
          color="primary"
          text
          @click="onSaveCredentials"
        >
          Save
        </v-btn>
      </v-card-actions>

    </v-card>
  </v-dialog>
</template>

<script>

export default {
  data() {
    return {
      dialog: false,
      showPassword: false,
    };
  },
  props: { credentials: Object },
  methods: {
    onSaveCredentials() {
      this.$emit('saveCredentials', this.credentials);
    },
    onOpen() {
      this.$emit('updateBusiness');
    },
  },
};
</script>

<style scoped>

</style>
